//#region estilos

import {keyframes} from 'tss-react';
import {makeStyles} from 'tss-react/mui';
import {PtrnConfigAgrupar} from './PtrnTablaGruposTypes';
import {PtrnDataInput} from '../../patronTypes';

// Define keyframes using @mui/system
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
`;

export const useTablaGrupoStyles = makeStyles()((theme) => ({
   /* Animation for expanding rows */
   rowExpand: {
      animation: `${fadeIn} 0.3s ease-in-out forwards`
   },

   /* Animation for collapsing rows */
   rowCollapse: {
      animation: `${fadeOut} 0.3s ease-in-out forwards`
   }
}));
//#endregion

